import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;

  gap: 20px;
`;

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  max-height: 700px;
  height: 100%;

  justify-content: space-between;

  gap: 20px;
`;
